<script lang="ts">import { Button } from "@infinitro/button";
import { t, Verbiage } from "@infinitro/content";
import { isMobile, isTablet, ModalDialog, pushModal } from "@infinitro/global";
import { GoogleIcon } from "@infinitro/icons";
import { Text } from "@infinitro/text";
import { campaignHeroFeatures } from "../../data/campaign-hero";
import FeatureBadge from "./feature-badge.svelte";
const handleSignup = () => {
	pushModal(ModalDialog.Auth, { tab: "signup" });
};
$: isPhone = $isMobile && !$isTablet;
$: taglineLines = $t(Verbiage.online_gambling_done_legitimately).split("\n");
</script>

<div class="content-panel">
	<Text
		type="title"
		titleSize="h1"
		titleWeight="semibold"
		customStyle="font-size: {isPhone
			? 'clamp(28px, calc((100vw - 32px) / 10), 40px)'
			: '50px'}; line-height: 1.15; height: auto;"
	>
		{#each taglineLines as line, index (index)}
			{#if index > 0}<br />{/if}{line}
		{/each}
	</Text>

	<div class="feature-row">
		{#each campaignHeroFeatures as feature (feature.label)}
			<FeatureBadge icon={feature.icon} label={feature.label} />
		{/each}
	</div>

	<div class="cta-row">
		<Button
			variant="primary"
			text={$t(Verbiage.rocketbet_register)}
			size="large"
			width={isPhone ? '100%' : '40%'}
			onClick={handleSignup}
		/>
		<Text bodySize="small" bodyWeight="semibold" textColor="gray">{$t(Verbiage.or)}</Text>
		<button
			type="button"
			class="google-button"
			on:click={handleSignup}
			aria-label={$t(Verbiage.rocketbet_register)}
		>
			<GoogleIcon className="google-button-icon" />
		</button>
	</div>
</div>

<style>
	.content-panel {
		display: flex;
		min-height: 250px;
		width: 100%;
		flex-direction: column;
		justify-content: space-around;
		padding-top: 1rem;
		padding-bottom: 1rem
}

	.feature-row {
		display: flex;
		flex-wrap: wrap;
		gap: 1rem
}

	.cta-row {
		margin-top: 1rem;
		display: flex;
		width: 100%;
		align-items: center;
		gap: 0.75rem
}

	.google-button {
		display: flex;
		flex-shrink: 0;
		cursor: pointer;
		align-items: center;
		justify-content: center;
		border-radius: 0.5rem;
		border-width: 0px;
		width: 44px;
		height: 44px;
		background: white
}

	:global(.google-button-icon) {
		height: 1.5rem;
		width: 1.5rem
}

	@media (min-width: 1024px) {
		.content-panel {
				min-height: 0px;
				justify-content: flex-start;
				gap: 1rem;
				padding-top: 0px;
				padding-bottom: 0px
		}
	}
</style>
